import { getDocs, limit, orderBy, query } from "firebase/firestore";
import { RepositoryFirebase } from "../common/repository.firebase";
import { Customer } from "./customer.entity";

class CustomerRepository extends RepositoryFirebase<Customer> {
  protected collection = "customers";
  protected entity = Customer;

  async listByName(maxCount = 500) {
    const q = query(this.getCollection(), orderBy("name"), limit(maxCount));
    const snap = await getDocs(q);
    return await Promise.all(snap.docs.map((d) => Customer.build(d.id, d.data())));
  }

  async searchByNameOrPhone(term: string, maxCount = 500) {
    const normalized = term.trim().toLowerCase();
    const items = await this.listByName(maxCount);
    if (!normalized) return items;
    return items.filter(
      (customer) =>
        customer.getName().toLowerCase().includes(normalized) ||
        customer.getPhone().toLowerCase().includes(normalized)
    );
  }
}

export const customerRepository = new CustomerRepository();
